import React, { useEffect } from 'react';

const LOGIN_KEY = 'user_login_time';
const SESSION_DURATION = 24 * 60 * 60 * 1000; // 24 horas em milissegundos

const SessionTimeout = ({ children }) => {
  useEffect(() => {
    const checkSession = () => {
      const currentPath = window.location.pathname;
      
      // Lista de rotas públicas que não precisam de autenticação
      const publicRoutes = ['/login', '/atend', '/cobranca_cliente', '/cobranca_lote_cliente', '/consulta', '/seabox_login', '/seabox'];
      
      // Se está em rota pública, não verifica sessão
      if (publicRoutes.includes(currentPath)) {
        return;
      }

      // Para rotas privadas, verifica token e sessão
      const loginTime = localStorage.getItem(LOGIN_KEY);
      const token = localStorage.getItem('token');
      
      if (!token || !loginTime) {
        // Redireciona para login apenas se não estiver em rota pública
        window.location.href = `${window.location.origin}/login`;
        return;
      }

      const currentTime = Date.now();
      const timeElapsed = currentTime - parseInt(loginTime, 10);
      
      if (timeElapsed > SESSION_DURATION) {
        localStorage.clear();
        window.location.href = `${window.location.origin}/login`;
      }
    };

    checkSession();

    const interval = setInterval(checkSession, 1000 * 60); // Verifica a cada minuto

    return () => clearInterval(interval);
  }, []);

  return <>{children}</>;
};

export default SessionTimeout;
